var _circle, _path, _circle2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetpassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 132,
    viewBox: "0 0 131 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.4091,
    cy: 66.3617,
    r: 65.4091,
    fill: "#DEF1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4091 47.1239C68.9807 47.1239 72.406 48.5427 74.9314 51.0682C77.4569 53.5936 78.8757 57.0189 78.8757 60.5905H80.9419C81.4264 60.5905 81.8932 60.7734 82.2487 61.1026C82.6043 61.4318 82.8226 61.883 82.8599 62.3661L84.4874 83.5279C84.5267 84.0366 84.3623 84.5401 84.0304 84.9275C83.6985 85.315 83.2262 85.5548 82.7175 85.5941L82.5694 85.5998H48.2489C47.7386 85.5998 47.2493 85.3972 46.8885 85.0364C46.5278 84.6756 46.3251 84.1863 46.3251 83.676L46.3308 83.5279L47.9584 62.3661C47.9957 61.883 48.2139 61.4318 48.5695 61.1026C48.9251 60.7734 49.3918 60.5905 49.8764 60.5905H51.9426C51.9426 57.0189 53.3614 53.5936 55.8868 51.0682C58.4123 48.5427 61.8376 47.1239 65.4091 47.1239ZM79.1585 64.4381H51.6578L50.3246 81.7522H80.4917L79.1585 64.4381ZM69.2567 68.2857V72.1333H61.5615V68.2857H69.2567ZM65.4091 50.9715C62.9304 50.9716 60.5474 51.9287 58.7571 53.643C56.9668 55.3573 55.9074 57.6966 55.7998 60.173L55.7902 60.5905H75.0281C75.028 58.1117 74.071 55.7287 72.3566 53.9384C70.6423 52.1481 68.303 51.0887 65.8266 50.9811L65.4091 50.9715Z",
    fill: "#555555"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.9138,
    cy: 52.8953,
    r: 7.69519,
    fill: "#DEF1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3567 60.5905H74.0662L73.5853 58.6667L74.0662 57.2239L76.9519 56.7429L81.2805 58.1858L79.3567 60.5905Z",
    fill: "#DEF1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetpassword);
export default __webpack_public_path__ + "static/media/resetpassword.cf23ea9980905c9e26691d8d1911bec1.svg";
export { ForwardRef as ReactComponent };